import { all, put, select, takeEvery } from 'redux-saga/effects';
import history from '@wix/da-shared-react/pkg/redux/routing/history';
import { appMounted } from '@wix/da-shared-react/pkg/redux/app/actions';
import { pushModal } from '@wix/da-shared-react/pkg/Modals/redux/actionCreators';
import { requestCloseGroup, requestFounderLeaveGroup, inviteToGroup } from '../actions/groups';
import { getIsGroupProfile, getProfileOwnerUser } from '../selectors/users';
import { ModalType } from '../../types/modals';

function* handleQueryParamTriggersSaga(action) {
  if (typeof window === 'undefined') {
    return;
  }
  const profileOwnerUser = yield select(getProfileOwnerUser);
  const isGroup = yield select(getIsGroupProfile);

  const params = new URLSearchParams(window.location.search);
  const reactivated = params.get('reactivated');

  // Handle account reactivation modal
  if (reactivated === '1') {
    yield put(
      pushModal(ModalType.ACCOUNT_REACTIVATED, {
        wrapInModal: false,
      })
    );
    // Remove the reactivated param from the URL
    params.delete('reactivated');
    history.replace({
      ...history.location,
      search: params.toString(),
    });
  }

  if (isGroup) {
    const flow = params.get('flow');
    switch (flow) {
      case 'founder-leave':
        yield put(requestFounderLeaveGroup(profileOwnerUser));
        break;

      case 'invite':
        yield put(inviteToGroup(profileOwnerUser));
        break;

      case 'close':
        yield put(requestCloseGroup(profileOwnerUser));
        break;

      default:
      // noop
    }
    if (flow) {
      // Remove the flow param from the URL
      params.delete('flow');
      history.replace({
        ...history.location,
        search: params.toString(),
      });
    }
  }
}

export default function* saga() {
  yield all([takeEvery(appMounted, handleQueryParamTriggersSaga)]);
}
